module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXRewardsTank/images/cards/cards_chieftain.ce978fc7.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXRewardsTank/images/cards/cards_chieftain.png
// module id = 1059
// module chunks = 16